import { TextField } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import { Autocomplete } from '@material-ui/lab';
import React from 'react';

const options = [
  'I have Bottlebooks product ID',
  'I have my own "External" ID',
];

export default function SplitButton() {
  const [open, setOpen] = React.useState(false);
  const anchorRef = React.useRef(null);
  const [selectedIndex, setSelectedIndex] = React.useState(1);

  const handleClick = () => {
    console.info(`You clicked ${options[selectedIndex]}`);
  };

  const handleMenuItemClick = (event, index) => {
    setSelectedIndex(index);
    setOpen(false);
  };

  const handleToggle = () => {
    setOpen((prevOpen) => !prevOpen);
  };

  const handleClose = (event) => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return;
    }

    setOpen(false);
  };

  return (
    <Grid container direction="column" alignItems="center">
      <Autocomplete
        sx={{ width: '350px', marginLeft: '15px' }}
        options={options}
        disablePortal
        getOptionLabel={(sourceFieldName) => sourceFieldName}
        getOptionSelected={(sourceFieldName, v) => {
          return sourceFieldName;
        }}
        value={options[0]}
        onChange={(e, value) => {
          // onChange(value);
        }}
        renderInput={(params) => (
          <TextField
            {...params}
            name="selectBBFieldName"
            label=""
            variant="outlined"
            fullWidth={true}
          />
        )}
      />
    </Grid>
  );
}
